<template>
  <div>
    <a v-for="(item, index) in items_data.unchanged" :key="`unchanged-${index}`"
       :href="`/items/${item.uuid}/edit`"
       class="kt-font-info">
      <i class="fa fa-minus" />{{ item.name }}<br>
    </a>

    <a v-for="(item, index) in items_data.added" :key="`added-${index}`"
       :href="`/items/${item.uuid}/edit`"
       class="kt-font-success">
      <i class="fa fa-plus-circle" />{{ item.name }}<br>
    </a>

    <a v-for="(item, index) in items_data.removed" :key="`removed-${index}`"
       :href="`/items/${item.uuid}/edit`"
       class="kt-font-danger">
      <i class="fa fa-minus-circle" />{{ item.name }}<br>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    rowProperties: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items_data() {
      const data = {
        unchanged: [],
        added: [],
        removed: [],
      };

      const old_items = this.rowProperties.old.items;
      const new_items = this.rowProperties.attributes.items;

      _.forEach(new_items, (new_item) => {
        const found = _.find(old_items, item => item.uuid === new_item.uuid);
        if (found) {
          data.unchanged.push(new_item);
        } else {
          data.added.push(new_item);
        }
      });

      _.forEach(old_items, (old_item) => {
        const found = _.find(new_items, item => item.uuid === old_item.uuid);

        if (!found) {
          data.removed.push(old_item);
        }
      });

      return data;
    },
  },
};
</script>
